<template v-if="isActive ">
  <v-chip :color="$finColors.primaryDark"
          dark
          class="pulse my-2"
          x-small>
    <fin-lexicon-text text="Realtime" auto-solve/>
  </v-chip>
</template>

<script>
import FinLexiconText from "@/components/common/lexicon/LexiconText"

export default {

  name: "fin-realtime-indicator",
  components: {FinLexiconText},
  props: {
    tradingPlatform: {
      type: String,
      required: true
    },
    instruments: {
      type: Array
    }
  },
  data() {
    return {
      isActive: false,
      interval: undefined,
      tradingHours: {
        "frankfurt": {
          start: "8:00",
          end: "20:00"
        },
        "xetra": {
          start: "9:00",
          end: "17:30"
        },
        "tradegate": {
          start: "08:00",
          end: "22:00"
        },
        "nasdaq": {
          start: "15:30",
          end: "22:00"
        },
        "newyork": {
          start: "15:30",
          end: "22:00"
        },
        "citibank": {
          start: "8:00",
          end: "22:00"
        },
        //(Gold, Silber, Palladium, Platin)
        "infront": {
          start: "00:00",
          end: "23:59"
        }
      }
    }
  },
  computed : {
    isRealTime() {
      return this.instruments.some(instrument => instrument.latestPrice.quality === 'RT')
    },
  },
  methods: {
    /**
     *
     * @param tradingPlatform Name of the trading Platform as String
     */
    updateIsTradingPlatformActive(tradingPlatform) {
      tradingPlatform = tradingPlatform.toLowerCase().replaceAll(" ", "")
      // First time without delay
      this.checkIsTradingPlatformActive(tradingPlatform)

      // Check every 60sec
      this.interval = setInterval(() => {
        this.checkIsTradingPlatformActive(tradingPlatform)
      }, 60000)
    },
    checkIsTradingPlatformActive(tradingPlatform) {
      const {start, end} = this.getTradingHours(tradingPlatform)

      const currentTime = new Date()
      if (start <= currentTime && currentTime <= end) {
        this.isActive = true
      } else {
        this.isActive = false
      }
    },
    getTradingHours(tradingPlatform) {
      let start = new Date()
      start.setHours(this.tradingHours[tradingPlatform].start.split(":")[0])
      start.setMinutes(this.tradingHours[tradingPlatform].start.split(":")[1])
      start.setSeconds(0)

      let end = new Date()
      end.setHours(this.tradingHours[tradingPlatform].end.split(":")[0])
      end.setMinutes(this.tradingHours[tradingPlatform].end.split(":")[1])
      end.setSeconds(0)

      return {
        start: start,
        end: end
      }
    }
  },
  watch: {
    tradingPlatform(newVal) {
      clearInterval(this.interval)
      this.updateIsTradingPlatformActive(newVal)
    }
  },
  mounted() {
    if (this.tradingPlatform) {
      this.updateIsTradingPlatformActive(this.tradingPlatform)
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },

}
</script>

<style lang="scss" scoped>
.disabled {
  background-color: $fin-color-accent-gray !important;
  opacity: .5;
}

.pulse {
  cursor: pointer;
  box-shadow: 0 0 0 rgba($fin-color-primary-dark, 0.4);
  animation: pulse 2.5s infinite;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba($fin-color-primary-dark, 0.4);
  }
  35% {
    -webkit-box-shadow: 0 0 0 7px rgba($fin-color-primary-dark, 0);
  }
  50% {
    -webkit-box-shadow: 0 0 0 0 rgba($fin-color-primary-dark, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba($fin-color-primary-dark, 0);
  }
}

@keyframes pulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba($fin-color-primary-dark, 0.4);
    box-shadow: 0 0 0 0 rgba($fin-color-primary-dark, 0.4);
  }
  35% {
    -moz-box-shadow: 0 0 0 7px rgba($fin-color-primary-dark, 0);
    box-shadow: 0 0 0 7px rgba($fin-color-primary-dark, 0);
  }
  50% {
    -moz-box-shadow: 0 0 0 0 rgba($fin-color-primary-dark, 0);
    box-shadow: 0 0 0 0 rgba($fin-color-primary-dark, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba($fin-color-primary-dark, 0);
    box-shadow: 0 0 0 0 rgba($fin-color-primary-dark, 0);
  }
}

</style>
